<template>
    <a class="header-menu-item _search-bar">
      <div @click.prevent="searchbar_open = !searchbar_open">
        <i class="fa fa-search"></i>
      </div>
      <form v-if="searchbar_open" class="pl-3" method="POST" action="/search">
        <input type="hidden" :value="csrfToken" name="_token">
        <div class="input-group">
          <input type="text" class="form-control" style="height: 32px;" placeholder="Search..." v-model="search_query" name="search_query">
          <div class="input-group-addon">
            <button type="submit" class="btn-primary">GO</button>
          </div>
        </div>
      </form>
    </a>
</template>

<script>
import { EventBus } from '../../app'

export default {
    created () {
      EventBus.$on('toggle-searchbar', (data) => {
        this.searchbar_open = !this.searchbar_open;
      })
    },
    data() {
        return {
          searchbar_open: false,
          search_query: '',
          csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },
};
</script>
